module.exports = __webpack_public_path__ + "static/img/sf-item-05.0dad63f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/partnership/sf-item-05.jpg
// module id = 6gJ2
// module chunks = 2